import React from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import {MemberShipSubscriptionTable} from "../../../UI/MembershipSubscription/MemberShipSubscriptionTable";

const MemberShipSubscription = () => {
  return (
    <div>
      <PanelHead title="Membership Subscription" />
      <PanelBody content={<MemberShipSubscriptionTable />} />
    </div>
  );
};

export default React.memo(MemberShipSubscription);
